import request from '@/config/axios'

/** 服务分类标签 */
export const SVC_CATEGORY_LABELS: Record<string, string> = {
  bazi: '命理排盘',
  feng: '风水堪舆',
  qimen: '奇门择吉',
  liuren: '六壬占卜'
}

/** 师傅服务配置 VO（监管视图，价格单位：分） */
export interface MasterServiceVo {
  id: number
  masterId: number
  masterName?: string
  catalogId: number
  catalogName?: string
  category?: string
  intro?: string
  price: number
  priceMin?: number
  priceMax?: number
  durationMinutes?: number
  status: number
}

/** 排班模板 VO（监管视图，只读） */
export interface MasterScheduleVo {
  id: number
  masterId: number
  masterName?: string
  period: number
  startTime: string
  endTime: string
  slotCount: number
  weekdays: string
  status: number
}

/** 时段明细 VO（监管视图） */
export interface MasterSlotVo {
  id: number
  masterId: number
  masterName?: string
  slotDate: string
  startTime: string
  endTime: string
  status: number
}

export const MasterSvcApi = {
  // 师傅服务配置分页（师傅姓名模糊/状态筛选）
  getServicePage: (params: { pageNo?: number; pageSize?: number; nickname?: string; status?: number }) => {
    return request.get({ url: '/xuanxue/master-service/page', params })
  },
  // 强制上下架师傅服务（监管：违规服务下架）
  updateServiceStatus: (id: number, status: number) => {
    return request.put({ url: '/xuanxue/master-service/update-status', params: { id, status } })
  },
  // 排班模板分页（只读）
  getSchedulePage: (params: { pageNo?: number; pageSize?: number; nickname?: string; status?: number }) => {
    return request.get({ url: '/xuanxue/master-schedule/page', params })
  },
  // 时段明细分页（师傅姓名/状态/日期范围筛选）
  getSlotPage: (params: {
    pageNo?: number
    pageSize?: number
    nickname?: string
    status?: number
    slotDate?: string[]
  }) => {
    return request.get({ url: '/xuanxue/master-slot/page', params })
  },
  // 关闭/开启未约时段（监管：已约时段后端拒绝）
  closeSlot: (id: number, closed: boolean) => {
    return request.put({ url: '/xuanxue/master-slot/close', params: { id, closed } })
  }
}
